import axios from 'axios';

export const GEM_METER_EVENT_ID = {
  COMPLETE_RATE: 1120001,
  ACTIVE_USER: 1120002,
  RETENTION: 1120003,
  VIEW_ERROR_DETAIL: 1120004,
  SHOW_THIS_ISSUE: 1120005,
  DONE_AN_ERROR: 1120006,
  CLICK_IT_OK: 1120007,
  CLICK_SHOW_IT: 1120008,
  CLICK_VIEW_ALL: 1120009,
  VIEW_FAQ: 1120010,
} as const;
type GemMeterEventIdKey = keyof typeof GEM_METER_EVENT_ID;

export const TEMPLATE_INSERT_EVENT_ID = 1070007;

interface EventParam {
  eventId: typeof GEM_METER_EVENT_ID[GemMeterEventIdKey] | typeof TEMPLATE_INSERT_EVENT_ID;
  properties?: {
    [key: string]: any;
  };
}

export default function trackEvent(params: EventParam) {
  return
}

function generateEventId(groupId: number, eventIndex: number) {
  return parseInt(groupId + eventIndex.toString().padStart(4, '0'));
}
// Third Party Placement Popup
const THIRD_PARTY_PLACEMENT_POPUP = 711;

export const THIRD_PARTY_PLACEMENT_POPUP_EVENT = {
  EDITOR_SHOW_THIRD_PARTY_PLACEMENT_POPUP: generateEventId(THIRD_PARTY_PLACEMENT_POPUP, 1),
  EDITOR_HIDE_THIRD_PARTY_PLACEMENT_POPUP: generateEventId(THIRD_PARTY_PLACEMENT_POPUP, 2),
  EDITOR_CLICK_TRY_NOW_THIRD_PARTY_PLACEMENT_POPUP: generateEventId(THIRD_PARTY_PLACEMENT_POPUP, 3),
};
